import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { CatDoc, Catalog } from 'src/app/shared/models/cat.model';
import { NgRedux } from '@redux/redux-compatibility.service';
import { AppState } from 'src/app/shared/redux/store';
import { CatService } from 'src/app/shared/services/cat.service';
import { UploadService } from 'src/app/shared/services/upload.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { DataElement, FileUpload, FileValidationParams, FileValidationResponse, newCatSystemVersion } from 'src/app/shared/models/common';
import { Config } from 'src/app/config';
import { DocMetadataHandler } from 'src/app/add-doc-metadata/services/add-doc-metadata.interface';
import { AddDocMetadataComponent } from 'src/app/add-doc-metadata/add-doc-metadata.component';

@Component({
    selector: 'create-cat-doc',
    templateUrl: './create-cat-doc.component.html',
    styleUrls: ['./create-cat-doc.component.scss'],
    providers: [
      {
        provide: DocMetadataHandler,
        useClass: DocMetadataHandler
      }
    ],
    standalone: false
})
export class CreateCatDocComponent implements OnInit {
  @Input() parentDoc: CatDoc;
  @Input() labelingExists: boolean = false;
  @Input() smpcExists: boolean = false;
  @Input() prescribingInfoExists: boolean = false;
  @Output() onClose = new EventEmitter();
  @Output() onDocCreated = new EventEmitter<CatDoc>();
  @ViewChild('addDocMetadataComponent') addDocMetadataComponent: AddDocMetadataComponent;

  docName: string;
  assetType: DataElement;
  isUploading: boolean;
  isValidFile: boolean;
  docS3Key: string;
  docFileName: string;
  fileName: string;
  saving: boolean;
  validationFileErrorMessage = "";
  fileValidTypes: string;

  newCatSystemVersion = newCatSystemVersion;
  
  get enableSubmit(): boolean {
    return this.docName != null && this.assetType != null && this.docFileName != null && (this.addDocMetadataComponent == null || this.addDocMetadataComponent.canSubmit());
  }

  get catalog(): Catalog {
    return this.ngRedux.getState().curCat;
  }

  get assetTypes(): DataElement[] {
    return this.catalog.catAssetTypeList
      .sort((a, b) => {
        if (a.label > b.label) return 1;
        if (a.label < b.label) return -1;
        return 0;
      });
  }

  constructor(
    private ngRedux: NgRedux<AppState>,
    private catService: CatService,
    private uploadService: UploadService,
    private authService: AuthService,
    private sharedService: SharedService,
    public docMetadataHandler: DocMetadataHandler
  ) {}

  ngOnInit(): void {
    if (this.parentDoc) {
      this.docName = this.parentDoc.docName;
    }
    this.fileValidTypes = this.uploadService.fileValidTypes;
  }

  close() {
    this.onClose.emit();
  }

  uploadFile($event) {
    const fileData: File = $event.target.files[0];
    if (!fileData) return;
    this.isValidFile = undefined;
    this.docFileName = null;
    this.fileName = null;
  

    this.isValidFile = this.uploadService.validateFile(
      fileData,
      this.fileValidTypes
      //SharedService.revDocFileTypes
    );

    if (!this.isValidFile) {
      
      this.validationFileErrorMessage = this.uploadService.fileInvalidTypeMessage;
      return;

    }

    this.isUploading = true;

    const file: FileUpload = new FileUpload();
    file.fileType = this.uploadService.getFileType(fileData);
    this.fileName = fileData.name;

    (async () => {
      await this.uploadService.uploadFile(fileData);
      file.file = fileData;

      this.docFileName = null;

      this.uploadService
        .getPresignedUrl(file, this.authService.getPresignedUrl)
        .subscribe(
          (data) => {
            this.uploadService.putFile(file, data).subscribe(
              (res) => {
                if (file.fileType === '.pdf') {
                  
                  let fileValidationParams: FileValidationParams = new FileValidationParams();
                  fileValidationParams.s3_key = data.s3Key;
                  fileValidationParams.env_id = this.ngRedux.getState().curEnv.id;
                  fileValidationParams.source_bucket = this.ngRedux.getState().curEnv.tmpS3Bucket;
                  this.uploadService.validateFileAdditionally(fileValidationParams).subscribe((fileValidationResponse: FileValidationResponse) => {
                    if (!fileValidationResponse.is_valid) {

                      this.isValidFile = false;
                      this.validationFileErrorMessage = fileValidationResponse.error_message.join('');

                    } else {
                      this.docS3Key = data.s3Key;
                      this.docFileName = file.file.name;
                    } 
                    
                    this.isUploading = false;
                    
                  })
                  
                  console.log(file.fileType);
                  // if (file.fileType.toLowerCase() == '.zip') {
                  //   this.uploadService
                  //     .loadInddFile(
                  //       this.ngRedux.getState().curEnv.tmpS3Bucket,
                  //       data.s3Key
                  //     )
                  //     .subscribe(
                  //       (pdfKey) => {
                  //         this.docS3Key = pdfKey;
                  //         this.isUploading = false;
                  //       },
                  //       (err) => {
                  //         this.removeFile();
                  //         this.sharedService.showInfoMessage({infoType: 'error', messageKey: err,  showToast: false})
                  //         this.isUploading = false;
                  //       }
                  //     );
                  // } else {

                  //}
                  } else {
                    this.docS3Key = data.s3Key;
                    this.docFileName = file.file.name;
                    this.isUploading = false;
                  }
              },
            
              (err) => {
                this.sharedService.showInfoMessage({infoType: 'error', messageKey: err,  showToast: false})
                this.isUploading = false;
              }
            );
            
          },
          
          (err) => {
            this.sharedService.showInfoMessage({infoType: 'error', messageKey: err,  showToast: false})
            this.isUploading = false;
          }
        );
    })();

    $event.target.value = '';
  }

  removeFile() {
    this.docFileName = null;
    this.fileName = null;
  }

  createDoc() {
    this.saving = true;

    let doc = new CatDoc();
    doc.docName = this.docName;
    if (this.parentDoc) {
      doc.parentDocId = this.parentDoc.docId;
    }
    doc.docName = this.docName;
    doc.catId = this.catalog.catId;
    doc.catVersionId = this.catalog.catVersionId;
    doc.docS3Key = this.docS3Key;
    doc.fileName = this.docFileName;
    doc.productId = this.catalog.productId;
    doc.assetType = this.assetType;
    const metadata = this.docMetadataHandler.getDocMetadataToAdd();
    if (metadata != null) {
      doc.metadata = metadata;
    }

    var encryptSw = !doc.fileName.toLocaleLowerCase().endsWith('.zip');

    this.catService.createIndDoc(doc).subscribe(
      (savedDoc) => {
        if (encryptSw) {
          this.uploadService
            .encryptFile(
              savedDoc.origDocId,
              'IND',
              this.ngRedux.getState().curEnv.tmpS3Bucket,
              this.ngRedux.getState().curEnv.docS3Bucket,
              doc.docS3Key
            )
            .subscribe(
              (res) => {
                this.catService.processIndDocAlg(savedDoc.runNum).subscribe();
                this.saving = false;
                this.onDocCreated.emit(savedDoc);
              },
              (err) => {
                this.sharedService.showInfoMessage({infoType: 'error', messageKey: err,  showToast: false})
                this.saving = false;
              }
            );
        } else {
          this.catService.processIndDocAlg(savedDoc.runNum).subscribe();
          this.saving = false;
          this.onDocCreated.emit(savedDoc);
        }
      },

      (err) => (this.saving = false)
    );
  }
  get envId() {
    return this.ngRedux.getState().curEnv.id;
  }
  get lang() {
    return this.ngRedux.getState().ui_lang
  }
  get catVersionId() {
    
    return this.catalog?.catVersionId;
  }
  get catSystemVersion() {
    return this.catalog?.systemVersion;
  }

  private get restrictedAssetTypeConfig(): {
    types: string[];
    exists: boolean;
    messageKey: string;
  }[] {
    return [
      {
        types: ['Reference - Labeling'],
        exists: this.labelingExists,
        messageKey: 'translate.cat.labelingAlreadyPresentWarning'
      },
      {
        types: ['SMPC'],
        exists: this.smpcExists,
        messageKey: 'translate.cat.smpcAlreadyPresentWarning'
      },
      {
        types: ['Prescribing Information'],
        exists: this.prescribingInfoExists,
        messageKey: 'translate.cat.prescribingInfoAlreadyPresentWarning'
      }
    ];
  }

  private get selectedAssetTypeText(): string {
    return this.assetType?.text ?? this.assetType?.label ?? null;
  }

  private get matchedRestrictedConfig() {
    const selected = this.selectedAssetTypeText;
    if (!selected) return null;
    return this.restrictedAssetTypeConfig.find(cfg =>
      cfg.types.includes(selected)
    );
  }

  get showAssetTypeExistsWarning(): boolean {
    const match = this.matchedRestrictedConfig;
    if (!match || !match.exists) return false;

    const selected = this.selectedAssetTypeText;
    const parentType =
      this.parentDoc?.assetType?.text ?? this.parentDoc?.assetType?.label;
    return !this.parentDoc || parentType !== selected;
  }

  get assetTypeExistsWarningMessage(): string {
    return this.matchedRestrictedConfig?.messageKey ?? '';
  }
}
